import { createAction, props } from '@ngrx/store';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';
import { ChooseLocation, LocationMenus, LocationTimeslot, Timeslot } from '../models';
import { DeliveryLocation } from '../models/delivery-location.model';

export enum ChooseLocationActionTypes {
  GetChooseLocationAction = '[ChooseLocation] GetChooseLocationAction',
  GetChooseLocationSuccessAction = '[ChooseLocation] GetChooseLocationSuccess',
  GetChooseLocationErrorAction = '[ChooseLocation] GetChooseLocationError',

  GetLocationTimeslotAction = '[ChooseLocation] GetLocationTimeslotAction',
  GetLocationTimeslotSuccessAction = '[ChooseLocation] GetLocationTimeslotSuccess',
  GetLocationTimeslotErrorAction = '[ChooseLocation] GetLocationTimeslotError',

  GetLocationMenusAction = '[ChooseLocation] GetLocationMenusAction',
  GetLocationMenusSuccessAction = '[ChooseLocation] GetLocationMenusSuccess',
  GetLocationMenusErrorAction = '[ChooseLocation] GetLocationMenusError',

  DeliveryLocationAction = '[ChooseLocation] DeliveryLocationAction',
  DeliveryLocationSuccessAction = '[ChooseLocation] DeliveryLocationSuccess',
  DeliveryLocationErrorAction = '[ChooseLocation] DeliveryLocationError',
  ClearStateAction = '[ChooseLocation] ClearStateAction',
  SetSelectedLocationAction = '[ChooseLocation] SetSelectedLocationAction',
  SetSelectedTimeslotAction = '[ChooseLocation] SetSelectedTimeslotAction',
  SetTimeslotExpiredAction = '[ChooseLocation] SetTimeslotExpiredAction',
  UpdateBackBtnValueSuccessAction = '[ChooseLocation] UpdateBackBtnValueSuccessAction',
  SetLocationPropTypes = '[ChooseLocation] SetLocationPropTypes',
  SetAcceptedAgeRestrictionYears = '[ChooseLocation] SetAcceptedAgeRestrictionYears',
  RemoveAcceptedAgeRestrictionYear = '[ChooseLocation] RemoveAcceptedAgeRestrictionYear',
}

export const getChooseLocationAction = createAction(ChooseLocationActionTypes.GetChooseLocationAction);
export const getChooseLocationSuccessAction = createAction(
  ChooseLocationActionTypes.GetChooseLocationSuccessAction,
  props<{ chooseLocation: ChooseLocation[] }>()
);
export const getChooseLocationErrorAction = createAction(
  ChooseLocationActionTypes.GetChooseLocationErrorAction,
  props<{ failure: AppStateFailure }>()
);

export const getLocationTimeslotAction = createAction(
  ChooseLocationActionTypes.GetLocationTimeslotAction,
  props<{ locationID: string; orderDate: string }>()
);
export const getLocationTimeslotSuccessAction = createAction(
  ChooseLocationActionTypes.GetLocationTimeslotSuccessAction,
  props<{ locationTimeslot: LocationTimeslot[] }>()
);
export const getLocationTimeslotErrorAction = createAction(
  ChooseLocationActionTypes.GetLocationTimeslotErrorAction,
  props<{ failure: AppStateFailure }>()
);

export const getLocationMenusAction = createAction(
  ChooseLocationActionTypes.GetLocationMenusAction,
  props<{ locationID: string; orderDate: string }>()
);
export const getLocationMenusSuccessAction = createAction(
  ChooseLocationActionTypes.GetLocationMenusSuccessAction,
  props<{ locationMenus: LocationMenus[] }>()
);
export const getLocationMenusErrorAction = createAction(
  ChooseLocationActionTypes.GetLocationMenusErrorAction,
  props<{ failure: AppStateFailure }>()
);

export const DeliveryLocationAction = createAction(ChooseLocationActionTypes.DeliveryLocationAction, props<{ locationID: string }>());
export const DeliveryLocationSuccessAction = createAction(
  ChooseLocationActionTypes.DeliveryLocationSuccessAction,
  props<{ deliveryLocation: DeliveryLocation }>()
);
export const DeliveryLocationErrorAction = createAction(
  ChooseLocationActionTypes.DeliveryLocationErrorAction,
  props<{ failure: AppStateFailure }>()
);

export const SetSelectedLocationAction = createAction(
  ChooseLocationActionTypes.SetSelectedLocationAction,
  props<{ selectedLocation: ChooseLocation }>()
);

export const SetSelectedTimeslotAction = createAction(
  ChooseLocationActionTypes.SetSelectedTimeslotAction,
  props<{ selectedTimeslot: Timeslot }>()
);

export const updateBackBtnValueSuccessAction = createAction(
  ChooseLocationActionTypes.UpdateBackBtnValueSuccessAction,
  props<{ btnValue: string }>()
);

export const setTimeslotExpiredAction = createAction(
  ChooseLocationActionTypes.SetTimeslotExpiredAction,
  props<{ isTimeslotExpired: boolean }>()
);

export const setLocationPropTypes = createAction(ChooseLocationActionTypes.SetLocationPropTypes, props<{ locationPropTypes: any }>());

export const setAcceptedAgeRestrictionYears = createAction(
  ChooseLocationActionTypes.SetAcceptedAgeRestrictionYears,
  props<{ year: number }>()
);

export const removeAcceptedAgeRestrictionYear = createAction(
  ChooseLocationActionTypes.RemoveAcceptedAgeRestrictionYear,
  props<{ year: number }>()
);

export const ClearStateAction = createAction(ChooseLocationActionTypes.ClearStateAction, props<{ actionType: string }>());
